import { HttpService } from "../http/HttpService";
import { SimulatedPayoutResponse } from "../http/protocol";

export class AffiliatesSimulatePayoutsService {
  http: HttpService;

  constructor(http: HttpService) {
    this.http = http;
  }

  simulate(): Promise<SimulatedPayoutResponse> {
    return this.http.get<SimulatedPayoutResponse>("/affiliates/payouts/simulate");
  }
}
